import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { RequestedRouteState } from '../../types';

type RouteAction = { type: string; payload: RequestedRouteState };

const initialState: RequestedRouteState = { route: '' };

const routeReducer = (
  state: RequestedRouteState,
  action: RouteAction,
): RequestedRouteState => {
  switch (action.type) {
    case types.REQUESTED_ROUTE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return initialState;
  }
};

type RouteContextType = [RequestedRouteState | null, Dispatch<RouteAction>];
export const RouteContext = createContext<RouteContextType>([
  initialState,
  () => initialState,
]);

const RouteProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [routeState, routeDispatch] = useReducer(routeReducer, initialState);

  return (
    <RouteContext.Provider value={[routeState, routeDispatch]}>
      {children}
    </RouteContext.Provider>
  );
};

export default RouteProvider;
